import { createThemeAssets, imageUrl } from '../createThemeAssets'

const themeImages = require.context('./images', true, /\.(png|jpe?g|webp|avif|gif|svg)$/)
const assets = createThemeAssets((path) => themeImages(`./${path}`))

export default {
    name: 'iceblue',
    label: 'Ice Blue',
    assets,
    cssVars: {
        '--theme-root-bg': '#020d18',
        '--theme-page-bg': [
            imageUrl(assets.home.pageBg),
            'radial-gradient(circle at 50% 0, rgba(134, 221, 255, .18) 0, rgba(62, 160, 255, 0) 42%)',
            'linear-gradient(180deg, rgba(8, 45, 72, .62) 0%, rgba(2, 13, 24, .88) 100%)'
        ].join(','),
        '--theme-page-bg-size': 'cover, 100% 7.2rem, 100% 100%',
        '--theme-page-bg-position': 'center top, center top, center top',
        '--theme-header-bg': 'linear-gradient(180deg, rgba(7, 43, 72, .96) 0%, rgba(2, 18, 32, .94) 100%)',
        '--theme-header-control-bg': '#082236',
        '--theme-header-control-border': '#5b9bb8',
        '--theme-header-control-border-gradient': 'linear-gradient(180deg, rgba(180, 232, 255, .42), rgba(76, 165, 202, 1))',
        '--theme-header-accent-bg': 'linear-gradient(180deg, #8ee9ff 0%, #0d5c83 100%)',
        '--theme-surface-bg': 'rgba(7, 43, 70, .62)',
        '--theme-surface-border': '#6aa7bf',
        '--theme-soft-text': '#b9e7f7',
        '--theme-bright-text': '#f1fbff',
        '--theme-input-bg': '#082236',
        '--theme-input-border': '#6aa7bf',
        '--theme-input-focus-bg': '#0b3451',
        '--theme-input-focus-border': '#9deeff',
        '--theme-input-focus-border-rgb': '157, 238, 255',
        '--theme-input-placeholder': 'rgba(185, 231, 247, .72)',
        '--theme-list-bg': 'rgba(2, 13, 24, .34)',
        '--theme-list-header-bg': 'rgba(8, 45, 72, .9)',
        '--theme-list-row-border': 'rgba(210, 245, 255, .25)',
        '--theme-active-bg': 'linear-gradient(180deg, #8ee9ff 0%, #0d5c83 100%)',
        '--theme-active-text': '#ffffff',
        '--theme-gold-bg': 'linear-gradient(180deg, #aeefff 0%, #1e7aa5 100%)',
        '--theme-gold-text': '#052032',
        '--theme-banner-bg': imageUrl(assets.home.bannerBg),
        '--theme-home-frame-corner-top-left': imageUrl(assets.home.frameCorners.topLeft),
        '--theme-home-frame-corner-top-right': imageUrl(assets.home.frameCorners.topRight),
        '--theme-home-frame-corner-bottom-left': imageUrl(assets.home.frameCorners.bottomLeft),
        '--theme-home-frame-corner-bottom-right': imageUrl(assets.home.frameCorners.bottomRight),
        '--theme-home-event-card-corner-top-left': imageUrl(assets.home.eventCardCorners.topLeft),
        '--theme-home-event-card-corner-top-right': imageUrl(assets.home.eventCardCorners.topRight),
        '--theme-home-event-card-corner-bottom-left': imageUrl(assets.home.eventCardCorners.bottomLeft),
        '--theme-home-event-card-corner-bottom-right': imageUrl(assets.home.eventCardCorners.bottomRight),
        '--theme-home-game-section-header-bg': imageUrl(assets.home.gameSectionHeaderBg),
        '--theme-home-jackpot-bg': imageUrl(assets.home.jackpotBg),
        '--theme-notification-bg-top1': imageUrl(assets.notification.bgTop1),
        '--theme-common-frame-corner-top-left': imageUrl(assets.common.frameCorners.topLeft),
        '--theme-common-frame-corner-top-right': imageUrl(assets.common.frameCorners.topRight),
        '--theme-common-frame-corner-bottom-left': imageUrl(assets.common.frameCorners.bottomLeft),
        '--theme-common-frame-corner-bottom-right': imageUrl(assets.common.frameCorners.bottomRight),
        '--theme-login-popup-image-bg': imageUrl(assets.login.popupBg),
        '--theme-home-classify-fixed-bg': 'linear-gradient(180deg, rgba(223, 247, 255, .04) 0%, rgba(223, 247, 255, 0) .16rem), linear-gradient(180deg, rgba(10, 48, 76, .98) 0%, rgba(3, 20, 34, .99) 100%)',
        '--theme-home-classify-item-bg': 'radial-gradient(circle at 12% 0, rgba(174, 239, 255, .2) 0, rgba(91, 178, 255, 0) 26%), linear-gradient(180deg, rgba(223, 247, 255, .1) 0%, rgba(223, 247, 255, 0) .1rem), linear-gradient(180deg, rgba(12, 64, 96, .96) 0%, rgba(4, 31, 50, .99) 100%)',
        '--theme-home-classify-icon-bg': '#0c5e84',
        '--theme-home-classify-nav-bg': 'linear-gradient(180deg, rgba(223, 247, 255, .12) 0%, rgba(223, 247, 255, 0) .12rem), linear-gradient(180deg, rgba(10, 58, 88, .96) 0%, rgba(3, 26, 44, .99) 100%)',
        '--theme-home-classify-nav-border': 'rgba(210, 245, 255, .22)',
        '--theme-home-classify-nav-shadow': 'inset 0 1px 0 rgba(229, 248, 255, .08), 0 .04rem .1rem rgba(4, 16, 34, .16)',
        '--theme-home-banner-panel-bg': 'linear-gradient(135deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .02), rgba(5, 48, 106, .5))',
        '--theme-home-section-top-bg': 'linear-gradient(180deg, rgba(6, 49, 112, .66) 0%, rgba(6, 49, 112, 0) 100%)',
        '--theme-home-notice-line-bg': 'linear-gradient(180deg, #9deeff 0%, #177ea7 100%)',
        '--theme-home-notice-item-bg': 'linear-gradient(-90deg, rgba(6, 49, 112, 0) 0%, rgba(6, 49, 112, .82) 100%)',
        '--theme-home-notice-icon-filter': 'brightness(0) saturate(100%) invert(69%) sepia(63%) saturate(1291%) hue-rotate(176deg) brightness(103%) contrast(101%) drop-shadow(0 .02rem .08rem rgba(157, 238, 255, .24))',
        '--theme-game-placeholder-surface': 'linear-gradient(180deg, rgba(13, 82, 172, .94) 0%, rgba(4, 39, 92, .99) 100%)',
        '--theme-game-placeholder-skeleton': 'linear-gradient(110deg, rgba(223, 247, 255, 0) 30%, rgba(157, 238, 255, .22) 50%, rgba(223, 247, 255, 0) 70%), linear-gradient(180deg, rgba(6, 49, 112, .58) 0%, rgba(3, 23, 53, .94) 100%)',
        '--theme-game-placeholder-fallback': 'radial-gradient(circle at 50% 18%, rgba(157, 238, 255, .18) 0%, rgba(157, 238, 255, 0) 36%), linear-gradient(180deg, rgba(6, 49, 112, .94) 0%, rgba(3, 23, 53, .99) 100%)',
        '--theme-game-placeholder-border': 'rgba(223, 247, 255, .14)',
        '--theme-game-title-bg': 'linear-gradient(180deg, rgba(8, 43, 66, .74) 0%, rgba(2, 13, 24, .92) 100%)',
        '--theme-game-title-text': '#f1fbff',
        '--theme-footer-border-top': imageUrl(assets.footer.borderTop),
        '--theme-footer-border-body': imageUrl(assets.footer.borderBody),
        '--theme-footer-title-text': '#dff7ff',
        '--theme-footer-body-text': '#b9e7f7',
        '--theme-footer-muted-text': 'rgba(223, 247, 255, .86)',
        '--theme-footer-copyright-text': '#f1fbff',
        '--theme-footer-menu-title-bg': 'linear-gradient(90deg, rgba(8, 55, 123, .92) 0%, rgba(3, 23, 53, .08) 100%)',
        '--theme-footer-menu-title-line': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-footer-menu-list-bg': 'linear-gradient(90deg, rgba(5, 36, 86, .64) 0%, rgba(3, 23, 53, .12) 100%)',
        '--theme-footer-menu-link-text': '#dff7ff',
        '--theme-home-banner-html-text': '#b9e7f7',
        '--theme-share-bg-top': imageUrl(assets.share.bgTop),
        '--theme-share-bg': imageUrl(assets.share.shareBg),
        '--theme-share-proxy-bg': imageUrl(assets.share.proxy),
        '--theme-person-vip-bg': imageUrl(assets.person.bgVip),
        '--theme-person-vip-pc-bg': imageUrl(assets.person.bgVipPc),
        '--theme-event-top-shell-bg': imageUrl(assets.event.topShellBg),
        '--theme-event-top-bg': imageUrl(assets.event.topBg),
        '--theme-event-top-right': imageUrl(assets.event.topRight),
        '--theme-event-detail-text': '#b9e7f7',
        '--theme-event-card-bg': 'rgba(7, 43, 70, .62)',
        '--theme-event-card-shadow': 'var(--theme-popup-panel-shadow)',
        '--theme-signin-vip-icon': imageUrl(assets.signIn.vipIcon),
        '--theme-signin-vip-icon-active': imageUrl(assets.signIn.vipIconActive),
        '--theme-signin-lock-icon': imageUrl(assets.signIn.lock),
        '--theme-signin-accent-text': '#FF8400',
        '--theme-signin-accent-border': '#9deeff',
        '--theme-signin-progress-line': '#1c72c9',
        '--theme-signin-disabled-btn-bg': 'linear-gradient(180deg, rgba(142, 164, 185, .96) 0%, rgba(87, 105, 126, .98) 100%)',
        '--theme-signin-disabled-btn-text': '#e8f4ff',
        '--theme-signin-day-bg': 'linear-gradient(180deg, #2f8ee8 0%, #0d5c83 100%)',
        '--theme-signin-day-border': '#b9e7f7',
        '--theme-signin-unlocked-bg': 'linear-gradient(180deg, #6bbdff 0%, #1767c4 99.29%)',
        '--theme-signin-secondary-amount-text': '#7bd0ff',
        '--theme-signin-nav-btn-bg': 'rgba(210, 245, 255, .22)',
        '--theme-signin-active-icon-shadow': '0px 2px 4px 0px rgba(3, 35, 82, .55)',
        '--theme-frame-line-vertical': 'linear-gradient(to bottom, transparent 0%, #4b91ad 10%, #9deeff 50%, #4b91ad 85%, transparent 100%)',
        '--theme-frame-line-horizontal': 'linear-gradient(to right, transparent 0%, #6aa7bf 15%, #9deeff 50%, #6aa7bf 85%, transparent 100%)',
        '--theme-tabbar-shell-bg': '#064d73',
        '--theme-tabbar-text': 'rgba(255, 255, 255, .68)',
        '--theme-tabbar-active-text': '#ffffff',
        '--theme-tabbar-float-bg': 'linear-gradient(180deg, rgba(4, 31, 79, .96) 0%, rgba(10, 67, 140, .98) 100%)',
        '--theme-tabbar-divider': 'rgba(174, 239, 255, .24)',
        '--theme-tabbar-active-bg': [
            imageUrl(assets.tabbar.activeBorders[0]),
            imageUrl(assets.tabbar.activeBorders[1]),
            imageUrl(assets.tabbar.activeBorders[2]),
            imageUrl(assets.tabbar.activeBorders[3]),
            'linear-gradient(180deg, #8ee9ff 0%, #0d5c83 100%)'
        ].join(','),
        '--theme-tabbar-active-bg-size': '.72rem .45rem, .72rem .45rem, .72rem .45rem, .72rem .45rem, 100% 100%',
        '--theme-tabbar-active-bg-position': 'top left, top right, bottom left, bottom right, bottom left',
        '--theme-popup-bg': 'linear-gradient(180deg, #061f33 0%, #0a4a6a 100%)',
        '--theme-popup-overlay-bg': 'rgba(2, 10, 18, .76)',
        '--theme-popup-close-bg': '#082236',
        '--theme-popup-close-border': '#6aa7bf',
        '--theme-popup-panel-bg': 'rgba(7, 43, 70, .62)',
        '--theme-popup-panel-fill': '#0b3451',
        '--theme-popup-panel-border': 'linear-gradient(180deg, rgba(180, 232, 255, .42), rgba(43, 137, 242, .18))',
        '--theme-popup-panel-shadow': 'inset .16rem .16rem .58rem 0 rgba(255, 255, 255, .16), inset -.16rem -.16rem .58rem 0 rgba(91, 178, 255, .12)',
        '--theme-panel-strong-bg': 'linear-gradient(180deg, #0e6ed2 0%, #063f90 100%)',
        '--theme-card-strong-bg': 'linear-gradient(180deg, #0b4f9e 0%, #062a61 100%)',
        '--theme-card-strong-border': '#6aa7bf',
        '--theme-popup-tabs-bg': 'rgba(8, 55, 123, .82)',
        '--theme-popup-mask-bg': 'rgba(5, 35, 82, .52)',
        '--theme-popup-box-bg': 'rgba(6, 49, 112, .92)',
        '--theme-popup-box-border': '#6aa7bf',
        '--theme-popup-box-shadow': 'inset 0 0 .1rem 0 rgba(174, 239, 255, .52)',
        '--theme-popup-amount-text': '#aeefff',
        '--theme-sidebar-bg': [
            'linear-gradient(180deg, rgba(8, 50, 80, .96) 0%, rgba(3, 23, 53, .98) 100%)',
            imageUrl(assets.home.pageBg)
        ].join(','),
        '--theme-sidebar-bg-size': '100% 100%, cover',
        '--theme-sidebar-border': 'rgba(174, 239, 255, .26)',
        '--theme-sidebar-menu-item-border': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-sidebar-hot-bg': imageUrl(assets.sidebar.hotBg),
        '--theme-sidebar-item-text': '#b9e7f7',
        '--theme-sidebar-item-active-bg': 'linear-gradient(-90deg, rgba(6, 49, 112, 0) 0%, #70dfff 100%)',
        '--theme-sidebar-item-active-line': 'linear-gradient(180deg, #9deeff 0%, #177ea7 100%)',
        '--theme-sidebar-control-bg': '#082236',
        '--theme-sidebar-control-border': '#6aa7bf',
        '--theme-sidebar-service-bg': 'linear-gradient(180deg, #8ee9ff 0%, #0d5c83 100%)',
        '--theme-sidebar-drawer-mask-bg': 'rgba(4, 35, 82, .58)'
    }
}
